import * as borogove from "borogove";
import { createContext, useContext } from "react";
import { useOutletContext } from "react-router";
import {
	FormLabel,
	FormControl,
	FormGroup,
	RadioGroup,
	Radio,
	Switch,
	FormControlLabel,
} from "@mui/material";

export type SettingsData = {
	enterIsSend: boolean;
	richTextToolbar: boolean;
	audibleNotifications: boolean;
	messageRequests: "invites" | "spam" | "strangers";
	e2ee: "none" | "pfs";
};
export const SettingsContext = createContext<SettingsData>({
	enterIsSend: true,
	richTextToolbar: false,
	audibleNotifications: false,
	messageRequests: "spam",
	e2ee: "none",
});

export const Settings = () => {
	const { persistence, setSettings } = useOutletContext<{
		persistence: borogove.persistence.KeyValueStore;
		setSettings: (x: SettingsData) => void;
	}>();
	const settings = useContext(SettingsContext);
	const {
		audibleNotifications,
		enterIsSend,
		richTextToolbar,
		messageRequests,
		e2ee,
	} = settings;

	return (
		<section>
			<h1>Settings</h1>

			<FormGroup>
				<FormControlLabel
					control={
						<Switch
							checked={enterIsSend}
							onChange={(e) => {
								persistence.set(
									"config#enterIsSend",
									e.target.checked ? "true" : "false",
								);
								setSettings({ ...settings, enterIsSend: e.target.checked });
							}}
						/>
					}
					label="Enter is Send"
				/>

				<FormControlLabel
					control={
						<Switch
							checked={richTextToolbar}
							onChange={(e) => {
								persistence.set(
									"config#richTextToolbar",
									e.target.checked ? "true" : "false",
								);
								setSettings({ ...settings, richTextToolbar: e.target.checked });
							}}
						/>
					}
					label="Formatting toolbar"
				/>

				<FormControlLabel
					control={
						<Switch
							checked={audibleNotifications}
							onChange={(e) => {
								persistence.set(
									"config#audibleNotifications",
									e.target.checked ? "true" : "false",
								);
								setSettings({
									...settings,
									audibleNotifications: e.target.checked,
								});
							}}
						/>
					}
					label="Audible notifications"
				/>
			</FormGroup>

			<FormGroup>
				<FormControl>
					<FormLabel>Hide chats in Message Requests area</FormLabel>
					<RadioGroup
						value={messageRequests}
						onChange={(e) => {
							persistence.set("config#messageRequests", e.target.value);
							setSettings({
								...settings,
								messageRequests: e.target.value as
									| "invites"
									| "spam"
									| "strangers",
							});
						}}
					>
						<FormControlLabel
							value="invites"
							control={<Radio />}
							label="Invites Only"
						/>
						<FormControlLabel
							value="spam"
							control={<Radio />}
							label="Invites & Suspected SPAM"
						/>
						<FormControlLabel
							value="strangers"
							control={<Radio />}
							label="Messages from Strangers"
						/>
					</RadioGroup>
				</FormControl>
			</FormGroup>

			<FormGroup>
				<FormControl>
					<FormLabel>Prefer end-to-end encryption</FormLabel>
					<RadioGroup
						value={e2ee}
						onChange={(e) => {
							persistence.set("config#e2ee", e.target.value);
							setSettings({
								...settings,
								e2ee: e.target.value as "none" | "pfs",
							});
						}}
					>
						<FormControlLabel value="none" control={<Radio />} label="None" />
						<FormControlLabel
							value="pfs"
							control={<Radio />}
							label="Forward Secrecy"
						/>
					</RadioGroup>
				</FormControl>
			</FormGroup>
		</section>
	);
};
